import { iconsSet } from "../../../../assets/icons/icons";
import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_ssbot.png",
      alt: "Estratégias SSBot",
    },
    title: "Conheça a SSBot",

    // String ou array de strings
    text: [
      "10 anos de experiência em robôs e automatização, nossos produtos são pensados para superar suas expectativas trazendo disciplina, gestão de risco e diversificação para seu capital.",
    ],
    testimonial: {
      text: "Foque seu tempo no que é importante para você e rentabilize seu dinheiro de forma inteligente, com a ajuda de nossos robôs.",
      author: {
        name: "Leandro Lopes, CNPI - Estrategista SSBot",
        // picture:
        //   "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/foto-edson-3-150x150.jpg",
      },
    },
  },

  strategies: {
    title: "Estratégias SSBot",
    heading: "Algoritmos avançados à sua disposição.",
    subtitle:
      "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão SSBot.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A SSBot",
    col1: [
      "A SSBot é uma empresa com expertise na criação de algoritmos eficazes e lucrativos para o mercado financeiro.",
      "Deixe de fora o lado emocional, utilizando nossas estratégias automatizadas que se adaptam a dinâmica do mercado e obtenha lucros consistentes com praticidade e segurança.",
    ],
    col2: [
      "Formada por um time de profissionais experientes como Leandro Lopes, 	analista CNPI-T com 10 anos de experiência no mercado financeiro, atualmente estrategista em operações automatizadas com diversos algoritmos proprietários e estrategista responsável da SSBot.",
    ],
  },

  stats: {
    title: "Alguns números da SSBot",
    subtitle: "Há 5 anos operando de forma automatizada em escala global.",
    data: [
      {
        value: "5",
        description: "Anos em atividade",
      },
      {
        value: "+10",
        description: "Estratégias validadas",
      },
      {
        value: "+8M",
        description: "Ordens executadas por ano",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da SSBot?",
    subtitle: "Veja quais as principais vantagens dos robôs da SSBot.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira a performance em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão SSBot",
  },

  // testimonials: [
  //   {
  //     text: "A Newbot é muito mais que estratégias para robôs que realmente funcionam, é atendimento especializado, orientação plena e aprendizado. Parabéns Edson e equipe!",
  //     author: "Eliseu Sandres",
  //     job: "Bancário",
  //     image_url:
  //       "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
  //   },
  //   {
  //     text: "Além de possuir estratégias extremamente bem refinadas, a Newbot proporciona também conhecimento compartilhado, atendimento direto e rápido e verdadeira preocupação com seus clientes.",
  //     author: "Victor Nardi Vilella",
  //     job: "Arquiteto de Sistemas",
  //     image_url:
  //       "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
  //   },
  // ],
};
